import React from "react";
import Slider from "react-slick";
import { useTSContext } from "../../../context/Dashboard/contextTScore";
import { useThemeMode } from "../../../context/contextTheme";
import "./style.css";

const VulMisCarousel = ({ score }) => {
  const { theme } = useThemeMode();
  const {
    hasAssets,
    hasMisconfig,
    cloudMisconfigAll
  } = useTSContext();

  const sliderSettings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
    swipe: true,
  };

  return (
    <>
      <div className="p-2 pb-0 mb-3">
        <div
          className="card vul-mis shadow-sm rounded-4"
          style={{
            width: 260,
            height: 180,
            backgroundColor: theme.background,
            border: `1px solid ${theme.border}`,
          }}
        >
          <Slider {...sliderSettings}>
            {/* Slide 1: Vulnerabilities */}
            <div>
              <div className="card-body text-center">
                <h6 style={{ fontSize: 18, color: theme.textMuted }}>Vulnerabilities</h6>
                <h4 className="fw-bold" style={{ fontSize: 28, color: theme.textColor }}>Detected</h4>
                <div className="d-flex justify-content-center mt-3">
                  {hasAssets ? (
                    <h1 className="fw-bold display-6 mb-0" style={{ color: theme.textMuted }}>
                      {score}
                    </h1>
                  ) : (
                    <p className="small px-2" style={{ color: theme.textMuted }}>
                      Start scanning to detect vulnerabilities.
                    </p>
                  )}
                </div>
              </div>
            </div>

            {/* Slide 2: Misconfigurations */}
            <div>
              <div className="card-body text-center">
                <h6 style={{ fontSize: 18, color: theme.textMuted }}>Misconfigurations</h6>
                <h4 className="fw-bold" style={{ fontSize: 28, color: theme.textColor }}>Detected</h4>
                <div className="d-flex justify-content-center mt-3">
                  {hasMisconfig ? (
                    <h1 className="fw-bold display-6 mb-0" style={{ color: theme.textMuted }}>
                      {cloudMisconfigAll}
                    </h1>
                  ) : (
                    <p className="small px-2" style={{ color: theme.textMuted }}>
                      Start scanning to detect misconfigurations.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </Slider>
        </div>
      </div>
      <style>
        {`
          .vul-mis .slick-dots {
            margin-bottom: 12px;
            position: absolute;
          }
        `}
      </style>
    </>
  );
};

export default VulMisCarousel;